import script from "./Legend.vue?vue&type=script&setup=true&lang=ts"
export * from "./Legend.vue?vue&type=script&setup=true&lang=ts"

import "./Legend.vue?vue&type=style&index=0&id=5e77ea6c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e77ea6c"]])

export default __exports__